export const API_ERRORS = {
  UNAUTHORIZED: { code: 'UNAUTHORIZED', message: 'Giriş yapmanız gerekiyor', http: 401 },
  FORBIDDEN: { code: 'FORBIDDEN', message: 'Bu işlem için yetkiniz yok', http: 403 },
  NOT_FOUND: { code: 'NOT_FOUND', message: 'Görev bulunamadı', http: 404 },
  CONFIRMATION_REQUIRED: { code: 'CONFIRMATION_REQUIRED', message: 'Silme işlemi için payload.confirm: true gerekli', http: 400 },
  VALIDATION_ERROR: { code: 'VALIDATION_ERROR', message: 'Doğrulama hatası', http: 422 },
  CHECKLIST_PARENT_NOT_FOUND: { code: 'CHECKLIST_PARENT_NOT_FOUND', message: 'Ana kontrol listesi maddesi bulunamadı', http: 404 },
  CHECKLIST_CHILD_NOT_FOUND: { code: 'CHECKLIST_CHILD_NOT_FOUND', message: 'Alt kontrol listesi maddesi bulunamadı', http: 404 },
  CHECKLIST_ITEM_NOT_FOUND: { code: 'CHECKLIST_ITEM_NOT_FOUND', message: 'Kontrol listesi maddesi bulunamadı', http: 404 },
  CHECKLIST_LIMIT_EXCEEDED: { code: 'CHECKLIST_LIMIT_EXCEEDED', message: 'Kontrol listesi madde limiti aşıldı', http: 422 },
  UNKNOWN_ACTION: { code: 'UNKNOWN_ACTION', message: 'Geçersiz aksiyon', http: 400 },
  INTERNAL_ERROR: { code: 'INTERNAL_ERROR', message: 'Sunucu hatası', http: 500 },
};

export const createApiError = (type, message, details) => ({
  code: type.code,
  message: message || type.message,
  http: type.http,
  details,
});

export const wrapResponse = ({
  success = true,
  action,
  data,
  summary,
  changes,
  error,
}) => ({
  success,
  ...(action && { action }),
  ...(data !== undefined && { data }),
  ...(summary && { summary }),
  ...(changes && { changes }),
  ...(error && { error }),
});
